const taxTypeList = [
  { value: 0, label: "Nenhum", ENUM: "NENHUM" },
  { value: 1, label: "Simples - Nacional", ENUM: "SIMPLES_NACIONAL" },
  {
    value: 2,
    label: "Simples - Nacional Excesso",
    ENUM: "SIMPLES_NACIONAL_EXCESSO",
  },
  {
    value: 3,
    label: "Normal - Lucro Presumido",
    ENUM: "NORMAL_LUCRO_PRESUMIDO",
  },
  { value: 4, label: "Normal - Lucro real", ENUM: "NORMAL_LUCRO_REAL" },
];

export default taxTypeList;
